
// Textarea and select clone() bug workaround | Spencer Tipping
// Licensed under the terms of the MIT source code license

// Motivation.
// jQuery's clone() method works in most cases, but it fails to copy the value of textareas and select elements. This patch replaces jQuery's clone() method with a wrapper that fills in the
// values after the fact.

// An interesting error case submitted by Piotr Przybyl: If two <select> options had the same value, the clone() method would select the wrong one in the cloned box. The fix, suggested by Piotr
// and implemented here, is to use the selectedIndex property on the <select> box itself rather than relying on jQuery's value-based val().

(function (original) {
  jQuery.fn.clone = function () {
    var result           = original.apply(this, arguments),
        my_textareas     = this.find('textarea').add(this.filter('textarea')),
        result_textareas = result.find('textarea').add(result.filter('textarea')),
        my_selects       = this.find('select').add(this.filter('select')),
        result_selects   = result.find('select').add(result.filter('select'));

    for (var i = 0, l = my_textareas.length; i < l; ++i) $(result_textareas[i]).val($(my_textareas[i]).val());
    for (var i = 0, l = my_selects.length;   i < l; ++i) {
      for (var j = 0, m = my_selects[i].options.length; j < m; ++j) {
        if (my_selects[i].options[j].selected === true) {
          result_selects[i].options[j].selected = true;
        }
      }
    }
    return result;
  };
}) (jQuery.fn.clone);

// trigger event sur show/hide
(function ($) {
  $.each(['show', 'hide'], function (i, ev) {
    var el = $.fn[ev];
    $.fn[ev] = function () {
      let ret = el.apply(this, arguments);
      this.trigger(ev);
      return ret;
    };
  });
})(jQuery);


// Importer des lib JS depuis JS lui même
(function($)
{
    /*
     * $.import_js() helper (for JavaScript importing within JavaScript code).
     */
    var import_js_imported = [];

    $.extend(true,
    {
        import_js : function(script)
        {
            var found = false;
            for (var i = 0; i < import_js_imported.length; i++)
                if (import_js_imported[i] == script) {
                    found = true;
                    break;
                }

            if (found == false) {
                $("head").append('<script type="text/javascript" src="' + script + '"></script>');
                import_js_imported.push(script);
            }
        }
    });

})(jQuery);


/**
 * jQuery alterClass plugin
 *
 * Remove element classes with wildcard matching. Optionally add classes:
 *   $( '#foo' ).alterClass( 'foo-* bar-*', 'foobar' )
 *
 * Copyright (c) 2011 Pete Boere (the-echoplex.net)
 * Free under terms of the MIT license: http://www.opensource.org/licenses/mit-license.php
 *
 */
(function ( $ ) {
  

$.fn.indic_limit = function ( limit,  span_char) {

  var self = this;

  var maxLength = limit;
  self.on('keyup', function() {
    var length = self.val().length;
    var length = maxLength-length;
    span_char.text(length);
  });
  self.keyup();

}

  
$.fn.alterClass = function ( removals, additions ) {
  
  var self = this;
  
  if ( removals.indexOf( '*' ) === -1 ) {
    // Use native jQuery methods if there is no wildcard matching
    self.removeClass( removals );
    return !additions ? self : self.addClass( additions );
  }

  var patt = new RegExp( '\\s' + 
      removals.
        replace( /\*/g, '[A-Za-z0-9-_]+' ).
        split( ' ' ).
        join( '\\s|\\s' ) + 
      '\\s', 'g' );

  self.each( function ( i, it ) {
    var cn = ' ' + it.className + ' ';
    while ( patt.test( cn ) ) {
      cn = cn.replace( patt, ' ' );
    }
    it.className = $.trim( cn );
  });

  return !additions ? self : self.addClass( additions );
};

})( jQuery );


/**
 * [autosubmit Gestion du submit d'une form via ajax]
 * 
 * @param  {Function} done       fonction appelée en fin d'appel ajax si tout ok
 * @param  {[type]}   fail       fonction appelée en fin d'appel ajax si problème autre que validation
 * @param  {[type]}   validation fonction appelée en fin d'appel ajax si problème de validation (laravel retourne un 422: Unprocessable Entity)
 * @return {[type]}              [description]
 */

 function IsJsonString(str) {
  try {
      JSON.parse(str);
  } catch (e) {
      return false;
  }
  return true;
}

// chemin de sauvegarde / lecture des critère pour une form donnée
$.fn._mnemo_key = function() {
  let form_id = $(this).attr('id');
  if(!form_id) return null;
  return `_form_mnemonic::${form_id}::${full_url}`;
}

$.fn.load_form = function(subkey = 'default', filters = []) {
  let form = $(this);
  let key = form._mnemo_key();
  let mnemoData = localStorage.getDbObject(key, subkey);
  if(mnemoData) {
    // si on a un filtre on ne touche a rien est on load que ce qu'on nous demande
    if(!filters.length) form.clearForm(); 
    form.setDataJson(mnemoData, filters);
  }
  return mnemoData;
}

$.fn.dump_form = function(subkey = 'default') {
  let form = $(this);
  let key = form._mnemo_key();
  let data = form.getData('json');
  return localStorage.setDbObject(key, data, subkey);
} 

// supprime une entrée dans le localStorage pour la version demandée
$.fn.reset_form = function(lsg_id) {
  let form = $(this);
  localStorage.removeDbOject(lsg_id);
}



// on initialise la form avec le json
$.fn.setDataJson = function (jsonData, filters) {
  this.each(function () {
      const form = $(this);

      Object.entries(jsonData).forEach(([key, value]) => {
          if(!value) return;
          // if (key.endsWith('_text')) return; // Ignorer les clés _text (traitées via leur clé principale)

          const field = form.find(`[name="${key}"]`);

          if(filters.length && !filters.includes(key) && !field.hasClass('force_restore')) return; // on ignore les champs non présent dans les filtres si précisé


          if(field.hasClass('no_restore')) return;
          if (!field.length) return; // Si aucun champ trouvé, on passe

          if (field.is(':checkbox')) {
              // Gérer les checkboxes (peut être un tableau ou une seule valeur)
              field.prop('checked', false);
              [].concat(value).forEach(val => {
                  form.find(`[name="${key}"][value="${val}"]`).prop('checked', true);
              });
          } else if (field.is(':radio')) {
              // Gérer les boutons radio
              form.find(`[name="${key}"][value="${value}"]`).prop('checked', true);
          } else if (field.is('select')) {
            const values = [].concat(value);
            const texts = [].concat(jsonData[key + '_text'] || []);

            values.forEach((val, index) => {
                // Vérifier si l'option existe déjà
                if (!field.find(`option[value="${val}"]`).length && key) {
                    // Ajouter l'option manquante avec le texte correspondant (si dispo)
                    let search_key = key.replace(/\[\]/g, '');
                    if(selTab[$(this).attr('id')][search_key]) {
                      const optionText = texts[index] || val;
                      const sel_col = selTab[$(this).attr('id')][search_key][0].selectize;
                      sel_col.addOption({ text: optionText, id: val, selected: true });
                      sel_col.addItem(val);
                    }
                    else {
                      // console.log('search_key', search_key);
                      console.error(`Le tableau selectize ne contient pas la clé : ${search_key}, vérifiez l'id du champ`)
                    }
                }
            });

            // Appliquer la sélection
            field.val(values);
          } else {
              // Gérer les autres champs (input, textarea...)
              field.val(value);
          }
      });
  });

  return this;
};

// on récup un json avec la data de la form
$.fn.getDataJson = function() {
  const formData = new FormData(this[0]); // Convertir l'objet jQuery en élément DOM
  const json = {};

  formData.forEach((value, key) => {
      // on exclu certain champs sur leur nom
      if(['_token'].includes(key)) return;

      const field = this.find(`[name="${key}"]`); // Trouver le champ dans le formulaire

      if(field.hasClass('no_submit')) return;

      // Gérer les valeurs multiples (checkbox, select multiple)
      if (json[key]) {
          if (Array.isArray(json[key])) {
              json[key].push(value);
          } else {
              json[key] = [json[key], value];
          }
      } else {
          json[key] = value;
      }

      // Vérifier si c'est un select et ajouter le texte de l'option sélectionnée
      if (field.is('select')) {
          const selectedText = field.find('option:selected').map(function () {
              return $(this).text();
          }).get();

          // Stocker sous key_text si plusieurs valeurs ou une seule
          json[key + '_text'] = selectedText.length > 1 ? selectedText : selectedText[0];
      }
  });

  return json;
}

// on récupère les data de la form pour les rendre au format demandé
$.fn.getData = function(format, before = null) {
  var form = $(this);

  if (before && (typeof before == "function")) {
    if(!before(form)) return;   
  }

  // Sérialisation des groupes (explicit_name) de champs (name) spécifiques
  let explicit = {}
  form.find('.js_explicit').each(function(index, el) {
    let explicit_name = $(el).attr('explicit_name');
    let name = $(el).attr('name');
    if(!explicit[explicit_name]) explicit[explicit_name] = {};
    if(IsJsonString($(el).val()))
      explicit[explicit_name][name] = JSON.parse($(el).val());
    else
      explicit[explicit_name][name] = $(el).val();
    $(el).attr('disabled', true);
  });

  form.find("select.selectize.clean_on_submit").each(function(index, el) {
    if($(el).val() === '__blank__') { $(el).val(''); }
  });

  // Création d'un/des champs caché avec la valeur du json reprenant l'ensemble des champs spécifiques par groupe de champs
  Object.keys(explicit).forEach(function(key,index) {
    form.prepend(`<input type="hidden" name="${key}">`)
    form.find(`[name='${key}']`).val(JSON.stringify(explicit[key]));
  });

  if(format == 'serialized')
    return form.serialize();
  else
    return form.getDataJson();
}


$.fn.autosubmit = function(done, fail, validation, before) {
  this.off('submit');
  this.on('submit', function(event) {
    event.preventDefault();

    var form = $(this).clone(true);
    form.find('.no_submit').attr('disabled', true);
    serializedData = form.getData('serialized', before);
    

    $(this).data('serialize', serializedData);

    // Nettoyage des mask
    form.find('input.mask').each(function(index, el) {
      el.value = $(el).cleanVal();
    });

    // Post du formulaire
    $.ajax({
      type: form.attr('method'),
      url: form.attr('action'),
      data: serializedData,
      statusCode: {
        422: function (response) {
                if (validation && (typeof validation == "function")) {
                  validation(response);   
                }
             }
      }
    }).done(function(data) {
      submitDone = true;
      if (done && (typeof done == "function")) {
        done(data);   
      }
    }).fail(function(data) {
      if(data.status != "422") {
        fail(data.responseJSON);
      }
    });

  });
  return this;
}

/**
 * Ajout une scollbar horizontalle stylée sur un container
 */
$.fn.hscroll = function(auto_hide, position) {
    this.mCustomScrollbar("destroy");
    this.mCustomScrollbar({
      axis:"x", 
      theme: "inset-2-dark",
      autoHideScrollbar: auto_hide,
      scrollInertia: 0,
      scrollbarPosition: position || 'inside',
      keyboard:{ enable: true },
    });
    this.mCustomScrollbar('scrollTo','top');
}

/**
 * Ajout une scollbar horizontalle stylée sur un container
 */
$.fn.vscroll = function(auto_hide, position) {
    this.mCustomScrollbar("destroy");
    this.mCustomScrollbar({
      axis:"y", 
      theme: "inset-2-dark",
      scrollInertia: 0,
      autoHideScrollbar: auto_hide,
      scrollbarPosition: position || 'inside',
      keyboard:{ enable: true }
    });
    this.mCustomScrollbar('scrollTo','top');
}

/**
 * Ajout une scollbar horizontalle stylée sur un container
 */
$.fn.vhscroll = function(auto_hide, position) {
    this.mCustomScrollbar("destroy");
    this.mCustomScrollbar({
      theme: "inset-2-dark",
      axis:"yx",
      scrollInertia: 0,
      autoHideScrollbar: auto_hide,
      scrollbarPosition: position || 'inside',
      keyboard:{ enable: true }
    });
    this.mCustomScrollbar('scrollTo','top');
}




$.fn.clearForm = function() {

  this.find('.selectize-control:not(".do-not-empty")').find('.selectize-dropdown-header').trigger('mousedown');

  return this.each(function() {
    if ($(this).hasClass('do-not-empty')) return;

    var type = this.type, tag = this.tagName.toLowerCase();
    if (tag == 'form')
      return $(':input',this).clearForm();
    if (type == 'text' || type == 'password' || tag == 'textarea')
      this.value = '';
    else if (type == 'checkbox' || type == 'radio')
      this.checked = false;
    else if (tag == 'select')
      this.selectedIndex = "";

    $(this).change().focusout();
  });
};


/**
 * [showFormErrors Affiche dans une form les erreures d'un laravel validation error]
 * 
 * @param  {[type]} errorsJSON Json d'erreur de validation laravel
 */
$.fn.showFormErrors = function(errorsJSON){
  var form = $(this);
  
  form.find(".tips").qtip('destroy');
  form.find(".field_error").remove();
  form.find(".form-group").removeClass('has-error');
  form.find(".grid-container").removeClass('has-error');

  $.each(errorsJSON, function(ind, item) {
    form.find("label[for|='"+ind+"']").append("<span class='field_error'>&nbsp;&nbsp;<span error=\""+item+"\" class='tips glyphicon glyphicon-alert'></span></span>");
    form.find("label[for|='"+ind+"']").closest(".form-group").addClass('has-error');
    form.find("label[for|='"+ind+"']").closest(".grid-container").addClass('has-error');
    form.find("#"+ind).attr('tips', item);
  });

  form.find(".tips").qtip({
    content: {
      title: 'Erreur',
      attr: 'error'
    },
    position: {
      my: 'bottom center',  
      at: 'top center', 
    },
    style: 'qtip-red qtip-rounded qtip-shadow',
  });
}

/**
 * [showFormModal Affichage d'une modal, injection du body et resize en fonction d'un param de span dans le body]
 * @param  {[string]} formHtml    [contenu du body à afficher]
 * @param  {[string]} target      [target]
 * @param  {[string]} crud_rights [droits données]
 * @param  {[string]} idForm      [id du formulaire]
 * @return {[type]}               [description]
 */
$.fn.injectFormModal = function(formHtml, target, crud_rights, idForm) {
  var modal = $(this);
  if (typeof idForm === "undefined" || idForm === null) idForm = 'NotToFound';

  modal.find(target).html(formHtml);

  // on retaille la modal en fonction d'un span local (bofbof, mais que faire)
  var modal_size = modal.find(target).find("span#modal_param").attr('modal_size');

  if(modal_size) {
    modal.find(" > div.modal-dialog").removeClass('modal-sm');
    modal.find(" > div.modal-dialog").removeClass('modal-md');
    modal.find(" > div.modal-dialog").removeClass('modal-lg');
    modal.find(" > div.modal-dialog").addClass(modal_size);    
  }

  bindFormComponents();

  var form = modal.find(target).find('form#' + idForm);
  if ($(form).length == 0) form = modal.find(target).closest('form');
  if ($(form).length == 0) form = modal.find(target).find('form');

  rowLocked = $(form).find('#locked');
  rowLocked = !(typeof rowLocked === "undefined") && rowLocked.val() == 1;

  // on cherche un boutton submit et test les droits
  if ($(form).find('[type="submit"]').length > 0 && (crud_rights.indexOf("c") != -1 || crud_rights.indexOf("u") != -1) && !rowLocked) {
    $(form).find('[type="submit"]').show();
  }
  else {
    // mise en readonly du formulaire
    $.each($(form).find('input, select, textarea'), function(index, item) { // readonly des élements
      $(item).attr('readonly', 'readonly');

      if($(item).is('select')) {
        selId = $(item).attr('id');
        var selObj = selTab[$(form).attr('id')][selId][0].selectize;
        selObj.disable();
      }
    });
    if ($(form).find('[type="submit"]').length > 0) $(form).find('[type="submit"]').hide(); // suppression du bouton submit  
  }

  // on garde trace des valeurs à l'ouverture pour alerte en cas de modif non enregistrée
  if( $(form).length ) {
    $(form).data('serialize',$(form).serialize());
  }


}

// mini plug-in pour selctize : présente un bouton pour clean la selection
Selectize.define( 'clear_selection', function ( options ) {
    var self = this;

    self.plugins.settings.dropdown_header = {
        title: 'Vider'
    };
    this.require( 'dropdown_header' );

    self.setup = (function () {
        var original = self.setup;

        return function () {
            original.apply( this, arguments );
            this.$dropdown.on( 'mousedown', '.selectize-dropdown-header', function ( e ) {
                self.clear();
                if(self.settings.mode != 'multi') self.setValue( '__blank__' );
                self.close();
                self.blur();

                return false;
            });
        }
    })();
});


Selectize.define("auto_position", function () {
  var self = this;

  const POSITION = {
    top: 'top',
    bottom: 'bottom',
  };

  self.positionDropdown = (function () {
    return function () {
      const $control = this.$control;
      const offset = this.settings.dropdownParent === 'body' ? $control.offset() : $control.position();
      offset.top += $control.outerHeight(true);

      const dropdownHeight = this.$dropdown.prop('scrollHeight') + 5; 
      const controlPosTop = this.$control.get(0).getBoundingClientRect().top;
      const wrapperHeight = this.$wrapper.height();
      const controlPosBottom = self.$control.get(0).getBoundingClientRect().bottom
      const position =
        controlPosTop + dropdownHeight + wrapperHeight > window.innerHeight &&
          controlPosBottom - dropdownHeight - wrapperHeight >= 0 ?
          POSITION.top :
          POSITION.bottom;
      const w = this.$wrapper[0].style.width !== 'fit-content' ? this.settings.dropdownParent === 'body' ? 'max-content' : '100%' : 'max-content';
      const styles = {
        width: w,
        minWidth : $control.outerWidth(true),
        left: offset.left
      };

      if (position === POSITION.top) {
        const styleToAdd = { bottom: offset.top, top: 'unset' };

        if (this.settings.dropdownParent === 'body') {
          styleToAdd.top = offset.top - this.$dropdown.outerHeight(true) - $control.outerHeight(true);
          styleToAdd.bottom = 'unset';
        }
        Object.assign(styles, styleToAdd);
        this.$dropdown.addClass('selectize-position-top');
        this.$control.addClass('selectize-position-top');
      } else {
        Object.assign(styles, { top: offset.top, bottom: 'unset' });
        this.$dropdown.removeClass('selectize-position-top');
        this.$control.removeClass('selectize-position-top');
      }

      if (this.settings.dropdownParent !== 'body' && w === 'max-content' && $control.outerWidth(true) >= this.$dropdown.outerWidth(true)) {
        w = '100%';
      }

      this.$dropdown.css(styles);
    };
  }());
});